import React, { useState, useRef } from 'react';

import { useEscapeEvent } from '../../hooks/useEscapeEvent';
import { useRefClickEvent } from '../../hooks/useRefClickEvent';

import { Text } from '../Text';

import { PopUpBubble, PopUpIcon, PopUpContainer } from './styles';

import infoIcon from '@/images/info-icon.svg';

export function PopUp() {
  const [visibility, setVisibility] = useState(false);
  const popUpBubbleRef = useRef(null);

  const showPopUp = () => {
    setVisibility(!visibility);
  };

  useEscapeEvent(showPopUp);
  useRefClickEvent(popUpBubbleRef, showPopUp);

  return (
    <PopUpContainer
      ref={popUpBubbleRef}
      data-elementid="no-spam-pop-up"
      marginLeft={{ 0: 'xs', desktop: 'sm' }}
    >
      <PopUpIcon src={infoIcon} onClick={showPopUp} alt="pop-up icon" />
      <PopUpBubble isVisible={visibility}>
        <Text>
          We’ll send you a confirmation code to get started — we don’t believe
          in spam!
        </Text>
      </PopUpBubble>
    </PopUpContainer>
  );
}
